export default __webpack_public_path__ + "static/media/Item_Fragile_Resin.f9ec8223.png";